import React from 'react';

import SVGIcon, { GENERAL_ICONS } from 'src/components/svg';

import { remCss, scssVariables } from 'src/helpers';
import { BaseAlert } from './BaseAlert';
import { MCText, View } from '../basic';

export class InfoAlert extends BaseAlert {
  render() {
    const {
      title,
      close,
      titleTemplate = 'heading',
      iconTemplate = 'primary',
      closeBtn,
      icon = true,
      maxWidth = 340,
      width,
      titleEx,
      isTitleCenter = false,
      noBodyBorder = false,
      screenDetail
    } = this.props;
    const style = {};
    if (isTitleCenter) {
      style.textAlign = 'center';
    }

    return (
      <div
        className={'mc-popup-contain mc-alert-manager'}
        style={{
          maxWidth: remCss((width || maxWidth) + (screenDetail?.isMediumScreen ? 70 : 0)),
          width: '100%'
        }}
      >
        <div
          className={'mc-modal-header mc-flex-20-col' + (noBodyBorder ? ' mc-b-none' : '')}
          style={{
            ...(screenDetail?.isMediumScreen
              ? {
                  padding: `${remCss(46)}px ${remCss(60)}px ${remCss(30)}px ${remCss(60)}px`,
                  gap: remCss(24)
                }
              : {})
          }}
        >
          {icon && (
            <View className={'mc-flex-center'}>
              <SVGIcon
                iconname={GENERAL_ICONS.INFO}
                fill={scssVariables[`colors-mc-${iconTemplate}`]}
              />
            </View>
          )}
          {['string', 'number'].includes(typeof title) ? (
            <MCText
              {...{ [titleTemplate]: true }}
              size={20}
              weight={500}
              label={title}
              style={style}
            />
          ) : (
            title
          )}
          {titleEx}
          {close && closeBtn}
        </div>
        {this.renderBody()}
        {this.renderFooter()}
      </div>
    );
  }
}
